import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AddNewJob } from "../../features/AddNewJob/AddNewJobSlice";

const AddJob = () => {
  const dispatch = useDispatch();

  const [jobTitle, setJobTitle] = useState("");
  const [jobType, setJobType] = useState("");
  const [salary, setSalary] = useState("");
  const [date, setDate] = useState("");
  const newJob = {
    title: jobTitle,
    type: jobType,
    salary: Number(salary),
    deadline: date,
  };
  
  const navigate = useNavigate();
  const handleAddJobs = (e) => {
    e.preventDefault();
    dispatch(AddNewJob(newJob))
    .then(() => navigate("/"));
  };

  return (
    <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
      <h1 className="mb-10 text-center lws-section-title">Add New Job</h1>

      <div className="max-w-3xl mx-auto">
        <form onSubmit={handleAddJobs} className="space-y-6">
          <div className="fieldContainer">
            <label
              htmlFor="lws-JobTitle"
              className="text-sm font-medium text-slate-300"
            >
              Job Title
            </label>
            <select
              onChange={(e) => setJobTitle(e.target.value)}
              id="lws-JobTitle"
              value={jobTitle}
              name="lwsJobTitle"
              required
            >
              <option value="" hidden>
                Select Job
              </option>
              <option value="Software Engineer">Software Engineer</option>
              <option value="Software Developer">Software Developer</option>
              <option value="Full Stack Developer">Full Stack Developer</option>
              <option value="MERN Stack Developer">MERN Stack Developer</option>
              <option value="DevOps Engineer">DevOps Engineer</option>
              <option value="QA Engineer">QA Engineer</option>
              <option value="Product Manager">Product Manager</option>
              <option value="Social Media Manager">Social Media Manager</option>
              <option value="Senior Executive">Senior Executive</option>
              <option value="Junior Executive">Junior Executive</option>
              <option value="Android App Developer">
                Android App Developer
              </option>
              <option value="IOS App Developer">IOS App Developer</option>
              <option value="Frontend Developer">Frontend Developer</option>
              <option value="Frontend Engineer">Frontend Engineer</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobType">Job Type</label>
            <select
              value={jobType}
              onChange={(e) => setJobType(e.target.value)}
              id="lws-JobType"
              name="lwsJobType"
              required
            >
              <option value="" hidden>
                Select Job Type
              </option>
              <option value={"Full Time"}>Full Time</option>
              <option value={"Internship"}>Internship</option>
              <option value={"Remote"}>Remote</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobSalary">Salary</label>
            <div className="flex border rounded-md shadow-sm border-slate-600">
              <span className="input-tag">BDT</span>
              <input
                onChange={(e) => setSalary(e.target.value)}
                type="number"
                name="lwsJobSalary"
                id="lws-JobSalary"
                required
                className="!rounded-l-none !border-0"
                placeholder="20,00,000"
              />
            </div>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobDeadline">Deadline</label>
            <input
              onChange={(e) => setDate(e.target.value)}
              type="date"
              name="lwsJobDeadline"
              id="lws-JobDeadline"
              value={date}
              required
            />
          </div>

          <div className="text-right">
            <button
              type="submit"
              id="lws-submit"
              className="cursor-pointer btn btn-primary w-fit"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </main>
  );
};

export default AddJob;
